import { useState, useEffect } from "react";
import { Button, Box, TextField, Avatar } from "@mui/material";
import { UseHomeAdvertising } from "./UseHomeAdvertising";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../../components/ProgressCom";
import Detail from "../../../main/detail/Detail";
import { useRecoilState } from "recoil";
import { rsProgress, rsActiveMenu, rsParentCom } from "../../../RecoilStates";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function EditAdv(props) {
  const { toGregorian, toSolar } = require("jdate-convert");
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const navigate = useNavigate();
  const location = useLocation();
  const { validate, updateAdvItem } = UseHomeAdvertising();
  const [imgState, setImgState] = useState({
    file: undefined,
    url: undefined,
  });
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    advID: undefined,
    url: undefined,
    orderRow: undefined,
    width: undefined,
    height: undefined,
  });

  const [errorState, setErrorState] = useState({
    file: false,
    url: false,
    height: false,
    width: false,
  });

  useEffect(() => {
    if (location.state && location.state.model) {
      setImgState({ ...imgState, url: location.state.model.image });
      setState({
        id: location.state.model.id,
        advID: location.state.model.advID,
        url: location.state.model.url,
        orderRow: location.state.model.orderRow,
        height: location.state.model.height,
        width: location.state.model.width,
      });
    }
  }, [location.state]);

  const handleChangeImage = (e) => {
    const img = new Image();
    img.src = URL.createObjectURL(e.target.files[0]);
    img.onload = () => {
      setState({ ...state, width: img.width, height: img.height });
    };

    setImgState({
      ...imgState,
      file: e.target.files[0],
      url: URL.createObjectURL(e.target.files[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/advertisingmanagement",
            AdvID: location.state.AdvID,
            componentFaTitle: location.state.componentFaTitle,
          },
          {
            name: "ویرایش تبلیغ",
            url: "/advertisingmanagement/editAdvertising",
          },
        ],
      }}
    >
      {state ? (
        <Box display="grid" gap={3}>
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                value={state.url ? state.url : ""}
                error={errorState.url}
                label="آدرس"
                sx={{
                  textarea: {
                    direction: "rtl",
                  },
                }}
                multiline
                rows={2}
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, url: evt.target.value });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            {!isSmall && <Box gridColumn="span 6"></Box>}
            <Box
              gridColumn={isSmall ? "span 12" : "span 5"}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 5,
              }}
            >
              <Box component="label">
                <Avatar
                  sx={{
                    border: "1px solid #d9d9d9",
                    borderRadius: 3,
                    width: "100%",
                    height: imgState.url ? "auto" : "100px",
                    p: 1,
                  }}
                  src={imgState.url ? imgState.url : "/static/img/NoAdv.png"}
                  alt="img"
                />
                <input
                  type="file"
                  id="img"
                  name="avatarName"
                  accept="image/*"
                  multiple
                  onChange={handleChangeImage}
                  hidden
                />
              </Box>
            </Box>
            {!isSmall && <Box gridColumn="span 7"></Box>}
            <Box gridColumn={isSmall ? "span 6" : "span 2"}>
              <TextField
                fullWidth
                value={state.width ? state.width : ""}
                error={errorState.width}
                label="عرض"
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, width: evt.target.value });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            {!isSmall && <Box gridColumn="span 10"></Box>}
            <Box gridColumn={isSmall ? "span 6" : "span 2"}>
              <TextField
                fullWidth
                value={state.height ? state.height : ""}
                error={errorState.height}
                label="طول"
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, height: evt.target.value });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            {!isSmall && <Box gridColumn="span 10"></Box>}
            <Box
              gridColumn={isSmall ? "span 12" : "span 6"}
              sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                sx={{ mr: 2, width: "70px" }}
                variant="contained"
                onClick={() => {
                  if (validate(state, imgState, setErrorState) == 200) {
                    setProgress(true);
                    updateAdvItem(state, imgState.file, () => {
                      navigate("/advertisingmanagement", {
                        state: { ...location.state, isBack: true },
                        replace: true,
                      });
                    });
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                sx={{ width: "70px" }}
                variant="outlined"
                onClick={() => {
                  navigate("/advertisingmanagement", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                }}
              >
                بازگشت
              </Button>
            </Box>
            <Box gridColumn="span 9"></Box>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
